import React, { useEffect, useState } from 'react';
import { applyActionCode, confirmPasswordReset } from 'firebase/auth';
import { auth } from './firebase';
import { useLocation, useNavigate } from 'react-router-dom';

const ActionPage = () => {
  const [message, setMessage] = useState('Подтверждение...');
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search); // Используем location.search, а не location.hash
    const actionCode = queryParams.get('oobCode');
    const mode = queryParams.get('mode');
console.log(queryParams, "queyr", actionCode, mode)
    // Если отсутствуют обязательные параметры, показываем ошибку
    if (!actionCode || !mode) {
        console.log("некооректино", actionCode, mode)
      setMessage('Некорректная ссылка.');
      setLoading(false);
      return;
    }

    if (mode === 'verifyEmail') {
      // Логика для подтверждения email
      applyActionCode(auth, actionCode)
        .then(() => {
          setMessage('Email успешно подтвержден! Перенаправление...');
          setTimeout(() => navigate('/'), 3000);
        })
        .catch((error) => {
          setMessage('Ошибка при подтверждении. Попробуйте снова.');
          console.error(error);
        })
        .finally(() => setLoading(false));
    } else if (mode === 'resetPassword') {
      // Логика для сброса пароля
      const newPassword = prompt('Введите новый пароль:'); // Вы можете использовать более сложную форму
      if (newPassword) {
        confirmPasswordReset(auth, actionCode, newPassword)
          .then(() => {
            setMessage('Пароль успешно сброшен! Перенаправление...');
            setTimeout(() => navigate('/'), 3000);
          })
          .catch((error) => {
            setMessage('Ошибка при сбросе пароля. Попробуйте снова.');
            console.error(error);
          })
          .finally(() => setLoading(false));
      } else {
        setMessage('Пароль не был введен.');
        setLoading(false);
      }
    } else {
      // Если параметр mode не соответствует ни одному из известных вариантов
      setMessage('Некорректный режим.');
      setLoading(false);
    }
  }, [location.search, navigate]);

  return (
    <div
      style={{
        fontFamily: 'Roboto, sans-serif',
        backgroundColor: '#f4f6f8',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
          maxWidth: '400px',
        }}
      >
        <h2 style={{ color: '#2c3e50' }}>
          {location.search.includes('verifyEmail') ? 'Подтверждение Email' : 'Сброс пароля'}
        </h2>
        <p style={{ color: '#34495e', fontSize: '18px' }}>{message}</p>
        {loading && <p style={{ color: '#3498db' }}>Загрузка...</p>}
      </div>
    </div>
  );
};

export default ActionPage;